import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';
import { OrgService } from 'src/app/service/org.service';
import { CoursesService } from 'src/app/service/courses.service';
import { AcademicsService } from 'src/app/service/academics.service';
import { forkJoin } from 'rxjs';
@Component({
  selector: 'app-teacher-course-create',
  templateUrl: './teacher-course-create.component.html',
  styleUrls: ['./teacher-course-create.component.scss']
})
export class TeacherCourseCreateComponent implements OnInit {

  showLoader: boolean = false;
  creating: boolean = false;
  teachers: any = [];
  courses: any = [];
  orgId: any;
  username: any;

  createTeacherCourse = new FormGroup({
    teacher: new FormControl('', [
      Validators.required,
    ]),
    // teacherType: new FormControl('', [
    //   Validators.required,
    // ]),
    course: new FormControl('', [
      Validators.required, 
    ]),
    courseType: new FormControl('', [
      Validators.required,
    ]),
    remarks: new FormControl('', [
      // Validators.required,
    ]),
    active: new FormControl('', [
      Validators.required,
    ]),
  });

  constructor(
    private toastrService: ToastrService, public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router, public translate: TranslateService,
    public coursesService: CoursesService,
    public academicsService: AcademicsService
  ) {

  }

  ngOnInit(): void {
    this.orgId = this.globals.currentUserInfo.orgid;
    this.username = this.globals.currentUserInfo.username;
    this.showLoader = true;
    this.getAciveTeachersAndCourses();
    // this.teachers = [
    //   {
    //     id: 1,
    //     teacherNameAr: "علي",
    //     teacherNameEn: "Ali"
    //   }
    // ]
  }

  createTeacherCourseChange() {
    // let classHours = this.createTeacherCourse.controls.classHours.value;
    // let clinicalHours = this.createTeacherCourse.controls.clinicalHours.value;
    // this.createTeacherCourse.controls.totalHours.setValue(Number(classHours) + Number(clinicalHours));
  }

  createTeacherCourseSubmit() {
    if (this.createTeacherCourse.valid) {
      // console.log("creating teacher course");
      // console.log(this.createTeacherCourse.value);
      this.createTeacherCourseData(
        this.createTeacherCourse.controls.course.value,
        this.createTeacherCourse.controls.teacher.value,
        // this.createTeacherCourse.controls.teacherType.value,
        this.createTeacherCourse.controls.courseType.value,
        this.createTeacherCourse.controls.remarks.value,
        this.createTeacherCourse.controls.active.value
      );
    }else {
      this.createTeacherCourse.markAllAsTouched();
      this.createTeacherCourse.markAsDirty();
    }
  }

  
  getAciveTeachersAndCourses(){
    let bulkApis = [
      this.academicsService.getActiveSubjectList(this.orgId),
      this.academicsService.getActiveTeacherList(this.orgId)
    ];

    forkJoin(bulkApis).subscribe(
      data => {
        // console.log(data);
        if(typeof data[0] != undefined)
          this.courses = data[0];

        if(typeof data[1] != undefined)
          this.teachers = data[1];

        this.showLoader = false;
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_DATA_BE"));
        this.showLoader = false;
      }
    );
  }


  createTeacherCourseData(subjectid: number, teacherid: number, primarySecondary: string, remarks: string, active: string) {
    this.creating = true;

    this.academicsService.addTeacherCourse(this.username, this.orgId, subjectid, teacherid, primarySecondary, remarks, active)
      .subscribe(
        data => {
          if (data.sts == "SUCCESS") {
            this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
            this.router.navigate(['/academics/teacher-courses']);
          } else {
            this.creating = false;
            this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
          }
        },
        error => {
          this.creating = false;
          this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
        }
      );
  }

}

